import React, { useId } from 'react';

const TalentFactorLogoIcon = ({ width = 40, height = 40, className = "" }) => {
  // Generates a unique ID for this specific instance (e.g., ":r0:", ":r1:")
  const id = useId();

  // Create unique references for each gradient
  const g1Id = `g1-${id}`;
  const g2Id = `g2-${id}`;
  const g3Id = `g3-${id}`;

  const cp1Id = `cp1-${id}`;
  const cp2Id = `cp2-${id}`;
  const cp3Id = `cp3-${id}`;

  return (
    <svg 
      version="1.2" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 788 788" 
      width={width} 
      height={height} 
      className={className}
    >
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse" id={cp1Id}>
			<path d="m340.92 175.92c-7.93 108.12-4.15 107.72-3.25 216.53 0.22 26.17-6.17 129.14-2.53 316.46 0.38 19.88 10.15 34.65-6.49 34.06-67.04-2.34-132.74-74.75-133.93-139.54-3.3-180.56 6.08-404.87-3.9-406.25-38.73-5.38-189.44 6.92-191.81-7.71-0.33-2.1 4.43-133.63 156.51-137.76 78.29-2.12 108.35 2.5 254.25-2.36 13.99-0.47-0.52 13.28-8.75 23.41-34.27 42.14-46.24 36.38-60.1 103.16z"/>
		</clipPath>
		<linearGradient id={g1Id} x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0,693.656,-416.608,0,156.303,49.011)">
			<stop offset="0" stopColor="#ce32f8"/>
			<stop offset="1" stopColor="#8c17cf"/>
		</linearGradient>
		<clipPath clipPathUnits="userSpaceOnUse" id={cp2Id}>
			<path d="m374.2 435.6c32.04-70.24 110.71-110.02 168.11-111.27 6.85-0.15 165.15-1.04 166.96 1.14 1.83 2.19-2.7 54.44-15.76 74.92-63.28 99.21-181.33 52.23-181.42 75.91-0.44 110.95 17.44 194.52-75.87 247.84-37.05 21.17-70.78 21.69-71.5 14.38-1.38-14.2 0.65-14.15 1.35-178.36 0.4-93.22 0.7-102.81 8.13-124.56z"/>
		</clipPath>
		<linearGradient id={g2Id} x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0,418.748,-345.408,0,519.956,305.026)">
			<stop offset="0" stopColor="#059af4"/>
			<stop offset="1" stopColor="#0364cb"/>
		</linearGradient>
		<clipPath clipPathUnits="userSpaceOnUse" id={cp3Id}>
			<path d="m373.83 183.99c3.9-13.87 28.15-100.07 125.29-129.4 21.54-6.5 21.57-4.76 281.24-5.58 23.37-0.07-2.56 141.45-129.81 146.49-75.34 2.99-139.11-5.67-139.27 7.42-0.66 55.03 4.96 87.04-12.67 93.75-19.67 7.49-67.17 19.23-106.31 64.69-15.26 17.73-28.4 14.21-27.34-9.46 5.81-129.3-2.94-130.28 8.87-167.91z"/>
		</clipPath>
		<linearGradient id={g3Id} x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0,323.526,-423.172,0,558.59,26.011)">
			<stop offset="0" stopColor="#059af4"/>
			<stop offset="1" stopColor="#0364cb"/>
		</linearGradient>
      </defs>
      <g id="clipPath" clipPath={`url(#${cp1Id})`}>
		<g>
			<path fillRule="evenodd" fill='#8c17cf' d="m340.92 175.92c-7.93 108.12-4.15 107.72-3.25 216.53 0.22 26.17-6.17 129.14-2.53 316.46 0.38 19.88 10.15 34.65-6.49 34.06-67.04-2.34-132.74-74.75-133.93-139.54-3.3-180.56 6.08-404.87-3.9-406.25-38.73-5.38-189.44 6.92-191.81-7.71-0.33-2.1 4.43-133.63 156.51-137.76 78.29-2.12 108.35 2.5 254.25-2.36 13.99-0.47-0.52 13.28-8.75 23.41-34.27 42.14-46.24 36.38-60.1 103.16z"/>
			<path fillRule="evenodd" fill={`url(#${g1Id})`} d="m289.92 175.6c-7.93 108.12-4.15 107.72-3.25 216.52 0.22 26.18-6.17 129.15-2.53 316.47 0.38 19.87 10.15 34.64-6.49 34.06-67.04-2.35-132.74-74.76-133.93-139.55-3.3-180.56 6.08-404.86-3.9-406.25-38.73-5.37-189.44 6.93-191.81-7.71-0.33-2.09 4.43-133.63 156.51-137.75 78.29-2.13 108.35 2.49 254.25-2.37 13.99-0.46-0.52 13.29-8.75 23.42-34.27 42.14-46.24 36.37-60.1 103.15z"/>
		</g>
	</g>
	<g id="clipPath" clipPath={`url(#${cp2Id})`}>
		<g>
			<path fillRule="evenodd" fill='#0260c7' d="m374.2 435.6c32.04-70.24 110.71-110.02 168.11-111.27 6.85-0.15 165.15-1.04 166.96 1.14 1.83 2.19-2.7 54.44-15.76 74.92-63.28 99.21-181.33 52.23-181.42 75.91-0.44 110.95 17.44 194.52-75.87 247.84-37.05 21.17-70.78 21.69-71.5 14.38-1.38-14.2 0.65-14.15 1.35-178.36 0.4-93.22 0.7-102.81 8.13-124.56z"/>
			<path fillRule="evenodd" fill={`url(#${g2Id})`} d="m357.2 416.6c32.04-70.24 110.71-110.02 168.11-111.27 6.85-0.15 165.15-1.04 166.96 1.14 1.83 2.19-2.7 54.44-15.76 74.92-63.28 99.21-181.33 52.23-181.42 75.91-0.44 110.95 17.44 194.52-75.87 247.84-37.05 21.17-70.78 21.69-71.5 14.38-1.38-14.2 0.65-14.15 1.35-178.36 0.4-93.22 0.7-102.81 8.13-124.56z"/>
		</g>
	</g>
	<g id="clipPath" clipPath={`url(#${cp3Id})`}>
		<g>
			<path fillRule="evenodd" fill='#0260c7' d="m373.83 183.99c3.9-13.87 28.15-100.07 125.29-129.4 21.54-6.5 21.57-4.76 281.24-5.58 23.37-0.07-2.56 141.45-129.81 146.49-75.34 2.99-139.11-5.67-139.27 7.42-0.66 55.03 4.96 87.04-12.67 93.75-19.67 7.49-67.17 19.23-106.31 64.69-15.26 17.73-28.4 14.21-27.34-9.46 5.81-129.3-2.94-130.28 8.87-167.91z"/>
			<path fillRule="evenodd" fill={`url(#${g3Id})`} d="m355.92 160.99c3.91-13.87 28.15-100.07 125.3-129.4 21.54-6.5 21.57-4.76 281.24-5.58 23.37-0.07-2.56 141.45-129.81 146.49-75.34 2.99-139.11-5.67-139.27 7.42-0.66 55.03 4.96 87.04-12.68 93.75-19.67 7.49-67.17 19.23-106.3 64.69-15.26 17.73-28.4 14.21-27.34-9.46 5.81-129.3-2.95-130.28 8.86-167.91z"/>
		</g>
	</g>
    </svg>
  );
};

export default TalentFactorLogoIcon;